import { faSpinnerThird } from '@awesome.me/kit-3777c2145e/icons/duotone/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { classNames } from '../../utils/class-names.js';

const Spinner = ({ variant, className, size })=>/*#__PURE__*/ React.createElement(FontAwesomeIcon, {
        className: classNames(variant && `text-${variant}`, className),
        icon: faSpinnerThird,
        spin: true,
        size: size,
        role: "status",
        "aria-label": "Loading..."
    });

export { Spinner };
//# sourceMappingURL=Spinner.js.map
